import { NgModule } from "@angular/core";
import { SharedModule } from "@root/shared/shared.module";
import { MessageContainerComponent } from "@root/router/component/message/message-container/message-container.component";
import { MessageComponent } from "@root/router/component/message/message/message.component";
import { ClientComponent } from "./customer-service/client/client.component";
import { MessageItemComponent } from "./customer-service/message-item/message-item.component";
import { MESSAGE_DEFAULT_CONFIG_PROVIDER } from "@root/router/component/message/message.config";
import { NoteV2Component } from "./note-v2/note-v2.component";
import { ComponentModule } from "@root/component/component.module";
import { SyncTasksSubListComponent } from "./jobs/syn-task-list/syn-task-list.component";
import { DuplicateGuestComponent } from "./guest/duplicate-guest/duplicate-guest.component";
import { EditGuestComponent } from "./guest/edit-guest/edit-guest.component";
import { GuestTagComponent } from "./guest/guest-tag/guest-tag.component";
import { HourRoomCalendarComponent } from "./hour-room-calendar/hour-room-calendar.component";
import { VerticalTaskCalendarComponent } from "./vertical-task-calendar/task-calendar.component";
import { HouseOrderDetailComponent } from "./house-order-detail/house-order-detail.component";
import { HouseOrderBasicComponent } from "./house-order-detail/house-order-basic/house-order-basic.component";
import { HouseOrderFinanceComponent } from "./house-order-detail/house-order-finance/house-order-finance.component";
import { ContinueStayComponent } from "./house-order-detail/house-order-basic/continue-stay/continue-stay.component";
import { FinanceCompleteTableComponent } from "./house-order-detail/house-order-finance/finance-complete-table/finance-complete-table.component";
import { HouseOrderGuestComponent } from "./house-order-detail/house-order-guest/house-order-guest.component";
import { OrderGuestDetailComponent } from "./house-order-detail/house-order-guest/order-guest-detail/order-guest-detail.component";
import { OrderGuestSimilarComponent } from "./house-order-detail/house-order-guest/order-guest-similar/order-guest-similar.component";
import { AuditDetailsComponent } from "@root/router/component/property/audit-details/audit-details.component";
import { FailHousesComponent } from "@root/router/component/property/fail-houses/fail-houses.component";
import { EditTemplateComponent } from "./template/edit-template/edit-template.component";
import { OrderDetailSidebarComponent } from "./order-detail-sidebar/order-detail-sidebar.component";
import { RateDetailComponent } from "./house-order-detail/rate-detail/rate-detail.component";

import { EditRateComponent } from "./rate/edit-rate/edit-rate.component";
import { RateTplPickerComponent } from "./rate/rate-tpl-picker/rate-tpl-picker.component";
import { CreateTaskComponent } from "./task/create-task/create-task.component";
import { TaskDetailComponent } from "./task/task-detail/task-detail.component";
import { DepositComponent } from "./deposit/deposit.component";
import { HouseSelectComponent } from "@root/router/component/house-select/house-select.component";
import { CleanerAssignPickerComponent } from "@root/router/component/cleaner-assign-picker/cleaner-assign-picker.component";
import { BaseCalendarComponent } from "@root/router/component/calendar-picker/base-calendar/base-calendar.component";
import { OversaleCalendarComponent } from "@root/router/component/calendar-picker/oversale-calendar/oversale-calendar.component";
import { WillDeprecated_StopHouseCalendarComponent } from "./calendar-picker/stop-house-calendar/stop-house-calendar.component";
import { WidgetCheckGuideMenuComponent } from "@root/router/component/house-order-detail/widgets/check-guide-menu/check-guide-menu.component";
import { WidgetDepositComponent } from "@root/router/component/house-order-detail/widgets/deposit/deposit.component";
import { WidgetRemarkComponent } from "@root/router/component/house-order-detail/widgets/remark/remark.component";
import { ConditionSwitchPickerComponent } from "./condition-switch-picker/condition-switch-picker.component";
import { AddLabelPickerComponent } from "./add-label-picker/add-label-picker.component";
import { HousePickerComponent_v3_4 } from "./house-picker-v3_4/house-picker-v3_4.component";
import { HouseTypePickerComponent_v3_4 } from "./house-type-picker-v3_4/house-type-picker-v3_4.component";
import { GroupTypeSwitchPickerComponent } from "./group-type-switch-picker/group-type-switch-picker.component";
import { WidgetAutomationComponent } from "./house-order-detail/widgets/automation/automation.component";
import { CreateHouseComponent } from "./property/create-house/create-house.component";
import { CreateHouseTypeComponent } from "./property/create-house-type/create-house-type.component";
import { AddHouseComponent } from "./property/add-house/add-house.component";
import { AddQuickMessageGroupComponent } from "./quick-message/add-quick-message-group/add-quick-message-group.component";
import { ManageGroupComponent } from "./quick-message/manage-group/manage-group.component";
import { V4HousesModalSelectComponent } from "./v4/houses-modal-select/houses-modal-select.component";
import { V4HousesSelectComponent } from "./v4/houses-select/houses-select.component";
import { QuickMsgPickerComponent } from "./quick-message/quick-msg-picker/quick-msg-picker.component";
import { V4RoomTypesSelectComponent } from "./v4/room-types-select/room-types-select.component";
import { HouseOrderAutomationComponent } from "./house-order-detail/house-order-automation/house-order-automation.component";
import { V4CommonDepositListComponent } from "./v4/list/deposit/deposit.component";
import { V4CommonTaskListComponent } from "./v4/list/task/task.component";
import { V4CommonOrderListFilterComponent } from "./v4/filters/order-list-filter/order-list-filter.component";
import { V4CommonHouseListFilterComponent } from "./v4/filters/house-list-filter/house-list-filter.component";
import { V4CommonOrderListComponent } from "./v4/list/order/order.component";
import { V4CommonAccountListComponent } from "./v4/list/account/account.component";
import { WidgetHouseCardComponent } from "./house-order-detail/widgets/house-card/house-card.component";
import { V4RoomTypesModalSelectComponent } from "./v4/room-types-modal-select/room-types-modal-select.component";

import { PropertyDetailComponent } from "./property/property-detail/property-detail.component";
import { PricingComponent } from "./property/property-detail/sub-pages/pricing/pricing.component";
import { BookingSettingsComponent } from "./property/property-detail/sub-pages/booking-settings/booking-settings.component";
import { ChannelsLinkedComponent } from "./property/property-detail/sub-pages/channels-linked/channels-linked.component";
import { AdvancedComponent } from "./property/property-detail/sub-pages/advanced/advanced.component";
import { RoomTypeDetailComponent } from "./property/room-type-detail/room-type-detail.component";
import { RTChannelsLinkedComponent } from "./property/room-type-detail/sub-pages/channels-linked/channels-linked.component";
import { RTAdvancedComponent } from "./property/room-type-detail/sub-pages/advanced/advanced.component";
import { RTPricingComponent } from "./property/room-type-detail/sub-pages/pricing/pricing.component";
import { EditHouseComponent } from "./property/edit-house/edit-house.component";
import { WidgetPlanEditMessageComponent } from "./automation/edit/message/message.component";
import { WidgetPlanEditPriceComponent } from "./automation/edit/price/price.component";
import { WidgetPlanEditReviewComponent } from "./automation/edit/review/review.component";
import { WidgetPlanEditTaskComponent } from "./automation/edit/task/task.component";
import { NewComerPromotionComponent } from "./other/new-comer-promotion/new-comer-promotion.component";
import { WidgetPlanEditDepositComponent } from "./automation/edit/deposit/deposit.component";
import { WidgetTimePickerComponent } from "./house-order-detail/widgets/time-picker/time-picker.component";
import { WidgetFeeBlockComponent } from "./house-order-detail/widgets/fee-block/fee-block.component";
import { WidgetBasicBlockComponent } from "./house-order-detail/widgets/basic-block/basic-block.component";
import { WidgetCheckinBlockComponent } from "@root/router/component/house-order-detail/widgets/checkin-block/checkin-block.component";
import { WidgetExtraBlockComponent } from "@root/router/component/house-order-detail/widgets/extra-block/extra-block.component";
import { DemoPageComponent } from "./demo-page/demo-page.component";
import { RobotRulesComponent } from "./automation/robot-rules/robot-rules.component";
import { MessageRulesComponent } from "./automation/robot-rules/message-rules/message-rules.component";
import { RateRulesComponent } from "./automation/robot-rules/rate-rules/rate-rules.component";
import { RateGuestComponent } from "./automation/robot-rules/rate-rules/rate-guest/rate-guest.component";
import { ReplyGuestComponent } from "./automation/robot-rules/rate-rules/reply-guest/reply-guest.component";
import { PriceRulesComponent } from "./automation/robot-rules/price-rules/price-rules.component";
import { TaskRulesComponent } from "./automation/robot-rules/task-rules/task-rules.component";
import { WidgetRuleHousePickerComponent } from "./automation/robot-rules/widget/house-picker/house-picker.component";
import { CascadedTimePickerV2Component } from "./automation/robot-rules/widget/cascaded-time-picker-v2/cascaded-time-picker-v2.component";
import { DynContentPickerComponent } from "./automation/robot-rules/widget/dyn-content-picker/dyn-content-picker.component";
import { TestRuleComponent } from "./automation/robot-rules/test-rule/test-rule.component";
import { PropertyCalendarComponent } from "./property/property-calendar/property-calendar.component";
import { SingleStatusCalendarV2Component } from "./property/component/single-status-calendar-v2/single-status-calendar-v2.component";
import { MonthCalendarV2Component } from "./property/component/month-calendar-v2/month-calendar-v2.component";
import { SinglePriceCalendarV2Component } from "./property/component/single-price-calendar-v2/single-price-calendar-v2.component";
import { MonthPriceCalendarV2Component } from "./property/component/month-price-calendar-v2/month-price-calendar-v2.component";

import { RoomTypeCalendarComponent } from "./property/room-type-calendar/room-type-calendar.component";

import { OperateSidebarComponent } from "./operate-sidebar/operate-sidebar.component";
import { ManualOrderComponent } from "./operate-sidebar/manual-order/manual-order.component";
import { HousePriceComponent } from "./operate-sidebar/house-price/house-price.component";
import { HostexPriceComponent } from "./operate-sidebar/hostex-price/hostex-price.component";
import { HostexPanelComponent } from "./operate-sidebar/hostex-panel/hostex-panel.component";
import { ChannelPanelComponent } from "./operate-sidebar/channel-panel/channel-panel.component";
import { InventoryPanelComponent } from "./operate-sidebar/inventory-panel/inventory-panel.component";
import { HourRoomOrderComponent } from "./operate-sidebar/hour-room-order/hour-room-order.component";
import { CtripPriceFormComponent } from "./operate-sidebar/ctrip-price-form/ctrip-price-form.component";
import { HousesPickerComponent } from "./operate-sidebar/houses-picker/houses-picker.component";
import { TypesPickerComponent } from "./operate-sidebar/types-picker/types-picker.component";
import { EditPriceFormItemComponent } from "./operate-sidebar/widget/edit-price-form-item/edit-price-form-item.component";
import { EditStatusFormItemComponent } from "./operate-sidebar/widget/edit-status-form-item/edit-status-form-item.component";
import { EditInventoryFormItemComponent } from "./operate-sidebar/widget/edit-inventory-form-item/edit-inventory-form-item.component";
import { BookingMinimumDayComponent } from "./operate-sidebar/widget/booking-minimum-day/booking-minimum-day.component";
import { OSRulesSettingComponent } from "./operate-sidebar/rules-settings/rules-settings.component";
import { WidgetRulesSettingsFormComponent } from "./operate-sidebar/widget/rules-settings-form/rules-settings-form.component";
import { HostexSidebarComponent } from "./operate-sidebar/hostex-sidebar/hostex-sidebar.component";
import { ChannelSidebarComponent } from "./operate-sidebar/channel-sidebar/channel-sidebar.component";
import { HourReservationSidebarComponent } from "./operate-sidebar/hour-reservation-sidebar/hour-reservation-sidebar.component";
import { ThousandsSeparatorDirective } from "./operate-sidebar/directive/thousands-separator.directive";
import { OSPriceRulesSettingComponent } from "./operate-sidebar/price-rules-setting/price-rules-setting.component";
import { SyncTasksComponent } from "./jobs/sync-tasks/sync-tasks.component";
import { WidgetScheduleOnASpecificDayComponent } from "./automation/robot-rules/widget/schedule-on-a-specific-day/schedule-on-a-specific-day.component";

import { MultiHouseCalendarComponent } from "@root/router/component/calendar/multi-house-calendar/multi-house-calendar.component";
import { MultiHousePriceCalendarComponent } from "@root/router/component/calendar/multi-house-price-calendar/multi-house-price-calendar.component";
import { StatusLeftHouseGroupComponent } from "@root/router/component/calendar/multi-house-calendar/status-left-house-group/status-left-house-group.component";
import { StatusRightCalendarCellComponent } from "@root/router/component/calendar/multi-house-calendar/status-right-calendar-cell/status-right-calendar-cell.component";
import { CalendarDateCellComponent } from "@root/router/component/calendar/multi-house-calendar/calendar-date-cell/calendar-date-cell.component";
import { ReservationBarComponent } from "@root/router/component/calendar/multi-house-calendar/reservation-bar/reservation-bar.component";
import { DraggableOperatorComponent } from "./calendar/draggable-operator/draggable-operator.component";
import { OperateBarComponent } from "./calendar/operate-bar/operate-bar.component";
import { RecentOrderListComponent } from "./calendar/recent-order-list/recent-order-list.component";
import { RecentReservationListComponent } from "./calendar/recent-reservation-list/recent-reservation-list.component";
import { HostexStatusComponent } from "./calendar/hostex-status/hostex-status.component";
import { HouseOrderboxComponent } from "./calendar/house-orderbox/house-orderbox.component";
import { HouseTodayComponent } from "./calendar/house-today/house-today.component";
import { HouseTomorrowComponent } from "./calendar/house-tomorrow/house-tomorrow.component";
import { AutoPopoverComponent } from "@root/router/component/calendar/multi-house-calendar/auto-popover/auto-popover.component";
import { SingleRtStatusCalendarV2Component } from "./property/component/single-rt-status-calendar-v2/single-rt-status-calendar-v2.component";
import { WidgetNightsComponent } from "./automation/robot-rules/widget/nights/nights.component";
import { WidgetTimePickerPanelComponent } from "./house-order-detail/widgets/time-picker-panel/time-picker-panel.component";
import { ScrollingModule } from "@angular/cdk/scrolling";
import { MonthCalendarSkeletonComponent } from "@root/router/component/property/component/month-calendar-skeleton/month-calendar-skeleton.component";
import { BsListingsDetailComponent } from "./property/bs-listings-detail/bs-listings-detail.component";
import { BsListingsDetailBasisComponent } from "./property/bs-listings-detail/sub-pages/basis/basis.component";
import { BsListingsDetailBookingWidgetComponent } from "./property/bs-listings-detail/sub-pages/booking-widget/booking-widget.component";
import { WidgetLimitComponent } from "./automation/robot-rules/widget/limit/limit.component";
import { PricingRatioComponent } from "./property/property-detail/sub-pages/pricing-ratio/pricing-ratio.component";
import { V4GuestSelectComponent } from "./v4/guest-select/guest-select.component";
import { GapRulesComponent } from "./automation/robot-rules/gap-rules/gap-rules.component";
import { ShareLinkComponent } from "./calendar/share-link/share-link.component";
import { CopyPriceFormItemComponent } from "./operate-sidebar/widget/copy-price-form-item/copy-price-form-item.component";
import { CalendarLayoutComponent } from "./calendar/calendar-layout/calendar-layout.component";

const Modules = [ScrollingModule];

const Directives = [ThousandsSeparatorDirective];

const ExportedWidgets = [WidgetTimePickerComponent, WidgetTimePickerPanelComponent, WidgetRulesSettingsFormComponent];

const Widges = [
  WidgetCheckGuideMenuComponent,
  WidgetDepositComponent,
  WidgetRemarkComponent,
  WidgetAutomationComponent,
  WidgetHouseCardComponent,

  WidgetBasicBlockComponent,
  WidgetFeeBlockComponent,
  WidgetCheckinBlockComponent,
  WidgetExtraBlockComponent,
  WidgetPlanEditMessageComponent,
  WidgetPlanEditPriceComponent,
  WidgetPlanEditReviewComponent,
  WidgetPlanEditTaskComponent,
  WidgetPlanEditDepositComponent,

  WidgetRuleHousePickerComponent,
  WidgetScheduleOnASpecificDayComponent,
  WidgetLimitComponent,
  WidgetNightsComponent,
  CascadedTimePickerV2Component,
  DynContentPickerComponent,

  ...ExportedWidgets,
];

const OperateSidebarCmps = [
  HostexSidebarComponent,
  ChannelSidebarComponent,
  HourReservationSidebarComponent,
  OperateSidebarComponent,
  OSRulesSettingComponent,
  OSPriceRulesSettingComponent,
  ManualOrderComponent,
  HousePriceComponent,
  HostexPanelComponent,
  HostexPriceComponent,
  ChannelPanelComponent,
  TypesPickerComponent,
  EditPriceFormItemComponent,
  EditStatusFormItemComponent,
  EditInventoryFormItemComponent,
  BookingMinimumDayComponent,
  InventoryPanelComponent,
  HourRoomOrderComponent,
  HousesPickerComponent,
];
const OperateSidebarStandaloneCmps = [CtripPriceFormComponent, CopyPriceFormItemComponent];

const CalendarCmps = [
  PropertyCalendarComponent,
  RoomTypeCalendarComponent,
  SingleStatusCalendarV2Component,
  SinglePriceCalendarV2Component,
  SingleRtStatusCalendarV2Component,
  MonthCalendarSkeletonComponent,
  MonthCalendarV2Component,
  MonthPriceCalendarV2Component,

  AutoPopoverComponent,
  RecentOrderListComponent,
  RecentReservationListComponent,
  DraggableOperatorComponent,
  OperateBarComponent,
  MultiHouseCalendarComponent,
  MultiHousePriceCalendarComponent,
  StatusLeftHouseGroupComponent,
  StatusRightCalendarCellComponent,
  ReservationBarComponent,
  CalendarDateCellComponent,

  HostexStatusComponent,
  HouseTodayComponent,
  HouseTomorrowComponent,
  HouseOrderboxComponent,

  ShareLinkComponent,
  CalendarLayoutComponent,
];
const CalendarStandaloneCmps = [];

const AutomationCmps = [
  RobotRulesComponent,
  MessageRulesComponent,
  RateRulesComponent,
  RateGuestComponent,
  ReplyGuestComponent,
  PriceRulesComponent,
  TaskRulesComponent,
  GapRulesComponent,
  TestRuleComponent,
];

const PropertyDetailCmps = [
  WillDeprecated_StopHouseCalendarComponent,

  PropertyDetailComponent,
  PricingComponent,
  BookingSettingsComponent,
  PricingRatioComponent,
  ChannelsLinkedComponent,
  AdvancedComponent,

  RoomTypeDetailComponent,
  RTAdvancedComponent,
  RTChannelsLinkedComponent,
  RTPricingComponent,

  BsListingsDetailComponent,
  BsListingsDetailBasisComponent,
  BsListingsDetailBookingWidgetComponent,
];

const Components = [
  // ChannelPriceRatioComponent,
  HousePickerComponent_v3_4,
  HouseTypePickerComponent_v3_4,
  GroupTypeSwitchPickerComponent,
  RateTplPickerComponent,
  QuickMsgPickerComponent,
  EditHouseComponent,
  NewComerPromotionComponent,
  DemoPageComponent,

  SyncTasksComponent,
  ...AutomationCmps,
  ...CalendarCmps,
  ...OperateSidebarCmps,
  ...PropertyDetailCmps,
];

const PrivateComponents = [
  AuditDetailsComponent,
  FailHousesComponent,
  CreateHouseComponent,
  CreateHouseTypeComponent,
  AddHouseComponent,
  AddQuickMessageGroupComponent,
  ManageGroupComponent,
  HouseOrderAutomationComponent,
];

const V4Components = [
  V4HousesModalSelectComponent,
  V4RoomTypesModalSelectComponent,
  V4HousesSelectComponent,
  V4RoomTypesSelectComponent,
  V4CommonDepositListComponent,
  V4CommonTaskListComponent,
  V4CommonOrderListComponent,
  V4CommonAccountListComponent,
  V4CommonOrderListFilterComponent,
  V4CommonHouseListFilterComponent,
  V4GuestSelectComponent,
];

const StandaloneCmps = [...OperateSidebarStandaloneCmps, ...CalendarStandaloneCmps];

@NgModule({
  imports: [SharedModule, ComponentModule, ...Modules, ...StandaloneCmps],
  declarations: [
    AddLabelPickerComponent,
    // BreadcrumbComponent,
    MessageContainerComponent,
    MessageComponent,
    ClientComponent,
    MessageItemComponent,
    NoteV2Component,
    SyncTasksSubListComponent,
    DuplicateGuestComponent,
    EditGuestComponent,
    GuestTagComponent,
    HourRoomCalendarComponent,
    VerticalTaskCalendarComponent,
    EditTemplateComponent,

    HouseOrderDetailComponent,
    HouseOrderBasicComponent,
    HouseOrderFinanceComponent,
    ContinueStayComponent,
    FinanceCompleteTableComponent,
    HouseOrderGuestComponent,
    OrderGuestDetailComponent,
    OrderGuestSimilarComponent,
    OrderDetailSidebarComponent,
    RateDetailComponent,

    EditRateComponent,
    CreateTaskComponent,
    TaskDetailComponent,
    DepositComponent,

    HouseSelectComponent,
    CleanerAssignPickerComponent,
    BaseCalendarComponent,
    OversaleCalendarComponent,
    ConditionSwitchPickerComponent,
    // HouseOrderDetailComponent,
    // CouponListComponent
    ...Widges,
    ...Components,
    ...PrivateComponents,
    ...V4Components,
    ...Directives,
  ],
  exports: [
    AddLabelPickerComponent,
    // BreadcrumbComponent,
    ClientComponent,
    MessageItemComponent,
    HourRoomCalendarComponent,
    VerticalTaskCalendarComponent,
    EditTemplateComponent,

    OrderGuestDetailComponent,
    OrderGuestSimilarComponent,
    RateDetailComponent,
    OrderDetailSidebarComponent,
    TaskDetailComponent,

    HouseSelectComponent,
    CleanerAssignPickerComponent,
    OversaleCalendarComponent,

    ConditionSwitchPickerComponent,
    ...ExportedWidgets,
    ...Components,
    ...V4Components,

    ...StandaloneCmps,
    // MessageContainerComponent,
    // MessageComponent,
  ],
  providers: [MESSAGE_DEFAULT_CONFIG_PROVIDER],
})
export class ModuleSharedComponentModule {
  constructor() {
    console.log("[Init Done]: ModuleSharedComponentModule");
  }
}
